import axios from 'axios';



const authService = {
  signup: async (userData) => {
    const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/auth/signup`, userData);
    if (response.data.token) {
      sessionStorage.setItem('token', response.data.token);
      sessionStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response.data;
  },

  login: async (email, password, role) => {
    const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/auth/login`, {
      email,
      password,
      role
    });
    if (response.data.token) {
      sessionStorage.setItem('token', response.data.token);
      sessionStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response.data;
  },

  logout: () => {
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('user');
  },

  getCurrentUser: () => {
    const user = sessionStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  },

  getToken: () => {
    return sessionStorage.getItem('token');
  },

  isLoggedIn: () => {
    return !!sessionStorage.getItem('token');
  },

  getTechniciansBySkill: async (skill) => {
    const token = authService.getToken();
    const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/auth/technicians/by-skill`, {
      params: { skill },
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data.data;
  },

  getAllTechnicians: async () => {
    const token = authService.getToken();
    const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/auth/technicians`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data.data;
  },

  updateTechnicianSkills: async (skills) => {
    const token = authService.getToken();
    const response = await axios.patch(`${process.env.REACT_APP_API_BASE_URL}/api/auth/update-skills`, 
      { skills },
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
    return response.data;
  }
};

export default authService;
